import type { Goal, Outcome } from '../../../api/strategy-client/strategy-client.type';
import type { ExtendedEpic } from '../../../api/tasks-client/task-client.type';

/**
 * Transform a goal to match the ExtendedInitiative format for use with existing charts
 * Currently returns the goal object as-is to maintain compatibility with initiative-based chart components.
 *
 * @param {Goal} goal - The goal object to transform
 * @returns {any} The transformed goal in initiative format (currently a shallow copy of the goal)
 */
function transformGoalToInitiativeFormat(goal: Goal): any {
  return {
    ...goal,
  };
}

/**
 * Transform an outcome to match the ExtendedInitiative format for use with existing charts
 * Currently returns the outcome object as-is to maintain compatibility with initiative-based chart components.
 *
 * @param {Outcome} outcome - The outcome object to transform
 * @returns {any} The transformed outcome in initiative format (currently a shallow copy of the outcome)
 */
function transformOutcomeToInitiativeFormat(outcome: Outcome): any {
  return {
    ...outcome,
  };
}

/**
 * Transform an epic to match the ExtendedInitiative format for use with existing charts
 * Currently returns the epic object as-is to maintain compatibility with initiative-based chart components.
 * Epic already has the same data structure as Initiative (total_subtasks_over_time, contributing_teams_over_time, etc.)
 *
 * @param {ExtendedEpic} epic - The epic object to transform
 * @returns {any} The transformed epic in initiative format (currently a shallow copy of the epic)
 */
function transformEpicToInitiativeFormat(epic: ExtendedEpic): any {
  return {
    ...epic,
    end_date: epic.due_date,
  };
}

export { transformEpicToInitiativeFormat, transformGoalToInitiativeFormat, transformOutcomeToInitiativeFormat };
